import { TaxCategoriesStateType } from '@types'
import { arrayToObject } from '@utils/functional'
import { createReducer } from '@reduxjs/toolkit'
import {
  createTaxCategoryAction,
  deleteTaxCategoryAction,
  getTaxCategoriesAction,
  updateTaxCategoryAction,
} from '@store/actions/tax-categories'

const initialState = {} as TaxCategoriesStateType

const setOneCategory = (state, { payload: category }) => {
  return { ...state, [category.id]: category }
}

const taxCategoriesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getTaxCategoriesAction, (_, { payload: attributes }) => {
      return arrayToObject('id', attributes)
    })
    .addCase(createTaxCategoryAction, setOneCategory)
    .addCase(updateTaxCategoryAction, setOneCategory)
    .addCase(deleteTaxCategoryAction, (state, { payload: category }) => {
      const filteredState = { ...state }
      delete filteredState[category.id]
      return filteredState
    })
})

export default taxCategoriesReducer
